import { getNetworkConnection } from "./LocalStorageService";
import axios from "axios";
var _i18next = require("../i18n");

const baseApiUrl = `${process.env.REACT_APP_API_URL}/`;
const PraisoServices = async (ApiUrl, method, payload, params, headers) => {
    const url =
        ApiUrl.indexOf("https") === -1 ? `${baseApiUrl}${ApiUrl}` : ApiUrl;
    if (getNetworkConnection) {
        try {
            let response = null;
            if (method === "get") {
                response = await axios.get(
                    url,
                    {
                        params: params,
                        headers: headers,
                        ...payload,
                    }
                );
            } else if (method === "post") {
                response = await axios.post(
                    url,
                    {
                        ...payload,
                    },
                    {
                        params: params,
                        headers: headers,
                    }
                );
            } else if (method === "put") {
                response = await axios.put(
                    url,
                    {
                        ...payload,
                    },
                    {
                        params: params,
                        headers: headers,
                    }
                );
            } else if (method === "patch") {
                response = await axios.patch(
                    url,
                    {
                        ...payload,
                    },
                    {
                        params: params,
                        headers: headers,
                    }
                );
            } else if (method === "delete") {
                response = await axios.delete(
                    url,
                    {
                        params: params,
                        headers: headers,
                        ...payload,
                    }
                );
            }
            if (response && (response.status === 200 || response.status === 201)) {
                return {
                    status: {
                        code: response.data && response.data.status && (response.data.status.code || response.data.status.code === 0) ? response.data.status.code : 1,
                        message: response.data && response.data.status && (response.data.status.code || response.data.status.code === 0) ? _i18next.default.t(`API_ERROR_CODE_${response.data.status.code}_MESSAGE`) : `${_i18next.default.t("SOMETHING_WENT_WRONG")}, ${_i18next.default.t("PLEASE_TRY_AGAIN_LATER")}.`,
                    },
                    content: response.data && response.data.content ? response.data.content : null
                }
                // return response.data;
            } else {
                if (response && response.response) {
                    return {
                        status: {
                            code: response.response.status || response.response.status === 0 ? response.response.status : 1,
                            message:
                                response.response.status
                                    ? _i18next.default.t(`API_ERROR_CODE_${response.response.status}_MESSAGE`)
                                    : `${_i18next.default.t("SOMETHING_WENT_WRONG")}, ${_i18next.default.t("PLEASE_TRY_AGAIN_LATER")}.`,
                        },
                        content: null,
                    };
                } else if (response) {
                    return {
                        status: {
                            code: response.status ? response.status : 1,
                            message:
                                response.status || response.status === 0 ?
                                    _i18next.default.t(`API_ERROR_CODE_${response.status}_MESSAGE`)
                                    :
                                    `${_i18next.default.t("SOMETHING_WENT_WRONG")}, ${_i18next.default.t("PLEASE_TRY_AGAIN_LATER")}.`,
                        },
                        content: null,
                    };
                } else {
                    return {
                        status: {
                            code: 1,
                            message: `${_i18next.default.t("SOMETHING_WENT_WRONG")}, ${_i18next.default.t("PLEASE_TRY_AGAIN_LATER")}.`,
                        },
                        content: null,
                    };
                }
            }
        } catch (error) {
            const err = error as any;
            return {
                status: {
                    code:
                        err.response && err.response.status ? err.response.status : 1,
                    message:
                        err.response && (err.response.status || err.response.status === 0) ?
                            _i18next.default.t(`API_ERROR_CODE_${err.response.status}_MESSAGE`)
                            :
                            `${_i18next.default.t("SOMETHING_WENT_WRONG")}, ${_i18next.default.t("PLEASE_TRY_AGAIN_LATER")}.`,
                },
                content: null,
            };
        }
    }
};

export default PraisoServices;
